import { Spinner } from 'element-ui'

const YSpinner = Spinner
YSpinner.$depends = [Spinner]
YSpinner.$name = 'y-spinner'
YSpinner._name = 'Spinner 加载滚动'

export default YSpinner
